import { render } from "./SideNavEditor.vue?vue&type=template&id=6e6fa8c5"
import script from "./SideNavEditor.vue?vue&type=script&lang=js"
export * from "./SideNavEditor.vue?vue&type=script&lang=js"

import "./SideNavEditor.vue?vue&type=style&index=0&id=6e6fa8c5&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__